// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__oKnsX {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.styles_avatar__8FKRw {
    margin: 0 10px;
}

.styles_arrow__FfqBc {
    display: none;
}

.styles_activeTime__oVqEQ {
    font-size: 12px;
}

.styles_marginRtl__eXhkN {
    margin-left: 10px;
}

.styles_marginLtr__2RtNk {
    margin-right: 10px;
}

.styles_webcamIcon__IF31y {
    margin: 0 10px;
}
.styles_favIcon__WkPES{
    margin:0 10px;
}
@media only screen and (max-width: 650px) {

    .styles_arrow__FfqBc {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ActiveChatInfo/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;;IAEI;QACI,cAAc;IAClB;AACJ","sourcesContent":[".container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.avatar {\n    margin: 0 10px;\n}\n\n.arrow {\n    display: none;\n}\n\n.activeTime {\n    font-size: 12px;\n}\n\n.marginRtl {\n    margin-left: 10px;\n}\n\n.marginLtr {\n    margin-right: 10px;\n}\n\n.webcamIcon {\n    margin: 0 10px;\n}\n.favIcon{\n    margin:0 10px;\n}\n@media only screen and (max-width: 650px) {\n\n    .arrow {\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__oKnsX`,
	"avatar": `styles_avatar__8FKRw`,
	"arrow": `styles_arrow__FfqBc`,
	"activeTime": `styles_activeTime__oVqEQ`,
	"marginRtl": `styles_marginRtl__eXhkN`,
	"marginLtr": `styles_marginLtr__2RtNk`,
	"webcamIcon": `styles_webcamIcon__IF31y`,
	"favIcon": `styles_favIcon__WkPES`
};
export default ___CSS_LOADER_EXPORT___;
